import React, { useState } from "react";
import Input from "../common/components/Input";
import Cta from "../common/ui/Cta";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";
import leafImg from "../../assets/images/webp/innovate-leaf.webp";
import emailjs from "@emailjs/browser"; // Make sure this package is installed

const Innovate = () => {
  const formData = {
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  };

  const [value, setValue] = useState(formData);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(true);

    if (
      value.firstName !== "" &&
      value.lastName !== "" &&
      value.email !== "" &&
      value.number !== "" &&
      emailRegex.test(value.email)
    ) {
      setLoading(true);
      try {
        const templateParams = {
          from_name: `${value.firstName} ${value.lastName}`,
          from_email: value.email,
          phone_number: value.number,
          massage: value.message, // 👈 rename `message` to `message` in your state
        };

        await emailjs.send(
          "service_sbo0vdz", // Replace with your EmailJS service ID
          "template_hvzy3ws", // Replace with your EmailJS template ID
          templateParams,
          "uZvOaluLxkDzyUnE1" // Replace with your EmailJS public key
        );

        setValue(formData);
        setError(false);
      } catch (error) {
        console.error("Error sending email:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="w-full bg-custom-white flex flex-col justify-center items-center pt-20 pb-80 relative ">
      <img
        className="absolute top-0 right-0 max-w-[81.02px] max-lg:max-w-[60.99px] max-md:max-w-[40.45px]"
        src={leafImg}
        alt="leaf content"
      />
      <div className="container max-w-[872px] md:mx-auto xl:px-0">
        <div className="sm:text-center pb-10">
          <BlueTag center={{ ">": 640 }}>Contact Us</BlueTag>
          <Heading>Let's Innovate Together</Heading>
          <Paragraph className="max-w-[589px] mx-auto pt-3 leading-150">
            These align with the themes of innovation, excellence, and
            collaboration present in the design. Let me know if you’d like a
            different style!
          </Paragraph>
        </div>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-6 w-full max-md:gap-4 max-lg:px-14 max-md:px-0"
        >
          <div className="w-full flex items-center justify-between max-xl:gap-5 max-md:gap-4 max-md:flex-col">
            <div className="w-full max-w-[424px] flex flex-col gap-2 max-md:max-w-none">
              <Input
                htmlFor="first-name"
                id="first-name"
                label="First Name"
                type="text"
                onChange={(e) =>
                  setValue({ ...value, firstName: e.target.value })
                }
                value={value.firstName}
              />
              <p className="text-red-500 leading-100">
                {error && value.firstName.length === 0
                  ? "Please enter your first name"
                  : ""}
              </p>
            </div>
            <div className="w-full max-w-[424px] flex flex-col gap-2 max-md:max-w-none">
              <Input
                htmlFor="last-name"
                id="last-name"
                label="Last Name"
                type="text"
                onChange={(e) =>
                  setValue({ ...value, lastName: e.target.value })
                }
                value={value.lastName}
              />
              <p className="text-red-500 leading-100">
                {error && value.lastName.length === 0
                  ? "Please enter your last name"
                  : ""}
              </p>
            </div>
          </div>
          <div className="w-full flex items-center justify-between max-xl:gap-5 max-md:gap-4 max-md:flex-col">
            <div className="w-full max-w-[424px] flex flex-col gap-2 max-md:max-w-none">
              <Input
                htmlFor="email"
                id="email"
                label="Email"
                type="email"
                onChange={(e) => setValue({ ...value, email: e.target.value })}
                value={value.email}
              />
              <p className="text-red-500 leading-100">
                {error && value.email.length === 0
                  ? "Please enter your email"
                  : !emailRegex.test(value.email) && value.email.length > 0
                  ? "Please enter valid email address"
                  : ""}
              </p>
            </div>
            <div className="w-full max-w-[424px] flex flex-col gap-2 max-md:max-w-none">
              <Input
                htmlFor="number"
                id="number"
                label="Phone Number"
                type="number"
                onChange={(e) => setValue({ ...value, number: e.target.value })}
                value={value.number}
              />
              <p className="text-red-500 leading-100">
                {error && value.number.length === 0
                  ? "Please enter your number"
                  : error && value.number.length > 0 && value.number.length < 10
                  ? "Please enter valid phone number"
                  : ""}
              </p>
            </div>
          </div>
          <div>
            <label
              htmlFor="message"
              className="cursor-pointer pl-0.5 text-custom-black leading-100"
            >
              Massage
            </label>
            <textarea
              id="message"
              type="text"
              rows="6"
              cols="70"
              value={value.message}
              onChange={(e) => setValue({ ...value, message: e.target.value })}
              className="bg-white outline-none h-full max-h-[179px] border-[1.5px] border-mix-white rounded-lg w-full text-base font-normal p-4 focus:border-custom-dark-blue resize-none mt-1"
            />
          </div>
          <Cta
            type="submit"
            className="w-fit mx-auto mt-4 max-md:mt-2 max-md:max-w-none"
          >
            {loading ? "Sending..." : "Submit"}
          </Cta>
        </form>
      </div>
    </div>
  );
};

export default Innovate;
